/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetManyBaseAodRunsControllerAodRunQueryResponse, GetManyBaseAodRunsControllerAodRunQueryParams } from "../models/GetManyBaseAodRunsControllerAodRun";

export function getGetManyBaseAodRunsControllerAodRunUrl() {
  const res = { method: 'GET', url: `/aod-runs` as const }
  return res
}

/**
 * @summary Retrieve multiple AodRuns
 * {@link /aod-runs}
 */
export async function getManyBaseAodRunsControllerAodRun(params?: GetManyBaseAodRunsControllerAodRunQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetManyBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetManyBaseAodRunsControllerAodRunUrl().url.toString(), params, ... requestConfig })
  return res.data
}